import { Link } from 'react-router-dom';
import { useState } from 'react';
import { companyPath, getCompanyBranding } from '../utils/company';

interface CareerHeaderProps {
  onApply?: () => void;
  canApply?: boolean;
  sections: Array<{ id: string; label: string }>;
}

export function CareerHeader({ onApply, canApply, sections }: CareerHeaderProps) {
  const brand = getCompanyBranding();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <a className="career-skip" href="#career-content">Zum Inhalt springen</a>
      <header className="career-header">
        <div className="career-wrap career-header-inner">
          <Link to={companyPath()} className="career-brand" aria-label={`${brand.name} – alle Stellen`}>
            <img src={brand.logo} alt={brand.name} />
          </Link>
          <button type="button" className="career-menu-toggle" aria-expanded={menuOpen} aria-controls="career-navigation" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? 'Schließen' : 'Menü'} <span aria-hidden="true">{menuOpen ? '×' : '☰'}</span></button>
          <nav id="career-navigation" aria-label="Stellennavigation" className={`career-nav${menuOpen ? ' is-open' : ''}`}>
            {sections.map(section => <a key={section.id} href={`#${section.id}`} onClick={() => setMenuOpen(false)}>{section.label}</a>)}
            <Link to={companyPath('jobs')} onClick={() => setMenuOpen(false)}>Alle Stellen</Link>
          </nav>
          {onApply && canApply && <button type="button" className="career-button" onClick={onApply}>Jetzt bewerben <span aria-hidden="true">↗</span></button>}
        </div>
      </header>
    </>
  );
}

export function CareerFooter() {
  const brand = getCompanyBranding();
  return (
    <footer className="career-footer career-wrap">
      <div className="career-footer-top">
        <Link to={companyPath()} className="career-brand" aria-label={`Zur Startseite von ${brand.name}`}><img src={brand.logo} alt={brand.name} /></Link>
        <Link to={companyPath('jobs')}>Deine nächste Aufgabe entdecken <span aria-hidden="true">↗</span></Link>
      </div>
      <div className="career-footer-bottom">
        <p>© {new Date().getFullYear()} {brand.legalName}</p>
        <nav aria-label="Rechtliche Informationen">
          <Link to={companyPath('impressum')}>Impressum</Link>
          <Link to={companyPath('datenschutz')}>Datenschutz</Link>
          <Link to={companyPath('datenschutz-bewerber')}>Bewerberdatenschutz</Link>
        </nav>
      </div>
    </footer>
  );
}
